export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14783.ece28692.jpg";